import React from 'react';
import classNameBind from 'classnames/bind';
import { Tooltip, formatNumber } from '@piwikpro/ui-components';
import styles from './MeterChart.module.css';

const colorsPalette = ['#182BCB', '#0049D6', '#0078F6', '#38ACE9', '#56B9D1', '#92D0CE', '#CADDA7', '#FEEA99'];

const bindClasses = classNameBind.bind(styles);

interface Props {
  data: {
    name: string
    value: number
  }[]
  withLegend?: boolean
}

const MeterChart: React.FC<Props> = ({ data, withLegend }) => {
  const total = data.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <div className={bindClasses('wrapper')}>
      <div data-ppuc-id="MeterChart" className={bindClasses('chart')}>
        {total > 0 && data.map((element, index) => {
          const percentageOfAll = Math.round((element.value * 100) / total);

          return (
            <div
              data-ppuc-id="MeterChart.Element"
              key={element.name}
              className={bindClasses('element')}
              style={{
                width: `${percentageOfAll || 1}%`,
                backgroundColor: colorsPalette[index],
              }}
            >
              <Tooltip
                title={element.name}
                content={`${formatNumber(element.value)} (${percentageOfAll || '<1'}%)`}
              >
                <div style={{ opacity: 0 }}>Tooltip hook</div>
              </Tooltip>
            </div>
          );
        })}
      </div>
      {withLegend && (
        <div data-ppuc-id="MeterChart.Legend" className={bindClasses('legend')}>
          {data.map((element, index) => (
            <div
              key={element.name}
              className={bindClasses('legend-entry')}
            >
              <div
                className={bindClasses('color')}
                style={{
                  backgroundColor: colorsPalette[index],
                }}
              />
              <div className={bindClasses('name')}>
                {element.name}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MeterChart;
